import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// material-ui icons
import OrderIco from '@material-ui/icons/ChangeHistory';
// material-ui/ core components
import orderStyle from 'assets/jss/AdsOrder';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Button from 'components/UI/CustomButtons/Button';

/**
 * @description
 * Constant to map order selectors.
 * @param {Function} translation - Passed from HOC.
 * @returns {Array} - With the translated order selectors.
 */
const orderSelectors = translation => [
  {
    field: translation('flagged_ad.order.flags_count'),
    val: 'flags_count',
    column: 'flags',
  },
  {
    field: translation('flagged_ad.order.last_flag'),
    val: 'last_flagged_on',
    column: 'lastFlag',
  },
];

/**
 * @description
 * Stateless component
 *
 * @param {Object} props - Props from parent.
 */
const FlaggedAdListOrder = props => {
  const { classes, appliedOrder, changeOrder, t } = props;
  return (
    <React.Fragment>
      <h6>{t('ad.order.title')}</h6>
      <div className={classes.container}>
        <div className={classes.buttonGroup}>
          {orderSelectors(t).map(f => (
            <Button
              data-cy={`order-btn-${f.val}`}
              simple={f.val !== appliedOrder.orderField}
              onClick={() => changeOrder(f)}
              color="info"
              round
              className={classes.orderBtn}
              key={`order-btn-${f.val}`}
            >
              {f.field}
              {f.val === appliedOrder.orderField && (
                <OrderIco
                  className={`${classes.orderIco} ${!appliedOrder.orderAsc &&
                    classes.rotateIco}`}
                />
              )}
            </Button>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

/**
 * Order PropTypes
 * @param classes - styles
 * @param appliedOrder - current applied order
 * @param t - prop from HOC with string translations
 * @callback changeOrder - callback to change order type
 */
FlaggedAdListOrder.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  appliedOrder: PropTypes.shape({}).isRequired,
  changeOrder: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(orderStyle)(FlaggedAdListOrder));
